import React, { useEffect, useState } from "react";
import { ThreeCircles } from 'react-loader-spinner';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import moment from 'moment';
import { $, event } from "jquery";

import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../../redux/userSlice";

const TOP_KPIS_FIRST_PAGE = {
  totalvehiclecount: 0,
  fault_active_duration: 0,
  vehicle_with_fault: 0,
  vehicle_with_alarm: 0,
  vehicle_with_dtc: 0,
  faulty: 0,
  faultyslow: 0,
  faultyfast: 0,
  opportunitycharged: 0,
  opportunityslow: 0,
  opportunityfast: 0,
  fullcharged: 0,
  fullchargedslow: 0,
  fullchargedfast: 0,
  totalcharged: 0,
  totalslow: 0,
  totalfast: 0,
  slow: 0,
  fast: 0,
  both: 0,
  fault_occ_slow : 0,
  fault_occ_fast : 0,
  fault_occ : 0
};

export default function ChargingFirstPageKpisVehicle({ gloablfilter }) {
  const [topdata, setTopData] = useState(TOP_KPIS_FIRST_PAGE);
  const [faultactive, setFaultActive] = useState(TOP_KPIS_FIRST_PAGE);
  const [totalvehicle, setTotalVehicle] = useState(TOP_KPIS_FIRST_PAGE);
  const [modaldata, setModaldata] = useState([]);
  const [modaldata1, setModaldata1] = useState([]);
  const [currentRadioValue, setCurrentRadioValue] = useState("optioncharging")

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const appyData = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        totalvehiclecount: temp_result[0].total_vehicle_count.value
      }
      setTopData((prestate) => responce);
    }
  }

  const faultActive = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        fault_active_duration: temp_result.hits.total.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        faulty: temp_result.aggregations.groupby.buckets[0].Faulty.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        faultyslow: temp_result.aggregations.groupby.buckets[0].slowFaulty.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        faultyfast: temp_result.aggregations.groupby.buckets[0].fastFaulty.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        opportunitycharged: temp_result.aggregations.groupby.buckets[0].Opportunity.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        opportunityslow: temp_result.aggregations.groupby.buckets[0].OpportunitySlow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        opportunityfast: temp_result.aggregations.groupby.buckets[0].OpportunityFast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fullcharged: temp_result.aggregations.groupby.buckets[0].Full.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fullchargedslow: temp_result.aggregations.groupby.buckets[0].FullSlow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fullchargedfast: temp_result.aggregations.groupby.buckets[0].FullFast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        totalcharged: temp_result.aggregations.groupby.buckets[0].doc_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        totalslow: temp_result.aggregations.groupby.buckets[0].slow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        totalfast: temp_result.aggregations.groupby.buckets[0].fast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),

        fault_occ: temp_result.aggregations.groupby.buckets[0].Fault_occ.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fault_occ_fast: temp_result.aggregations.groupby.buckets[0].Fault_occ_fast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fault_occ_slow: temp_result.aggregations.groupby.buckets[0].Fault_occ_slow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      }
      setFaultActive((prestate) => responce);
    }
  }

  const vehicleActive = (data) => {
    const res_result = data;
    let slow = 0, fast = 0, both = 0;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;

      data.forEach((obj1, index) => {
        if (obj1.key.uniqueChargeType == "Both")
          both = obj1.total_vehicle_count.value

        if (obj1.key.uniqueChargeType == "Slow")
          slow = obj1.total_vehicle_count.value
        if (obj1.key.uniqueChargeType == "Fast")
          fast = obj1.total_vehicle_count.value

        responce = { both: both, slow: slow, fast: fast }
        setTotalVehicle((prestate) => responce);
      })
    }else{
      responce = { both: 0, slow: 0, fast: 0 }
      setTotalVehicle((prestate) => responce);
    }
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "chargingpage/topkpisfirstpage", body: { filterdata: gloablfilter } }, appyData)
    fetchData({ url: API_URL_MAIN + "chargingpage/totalchargedcycle", body: { filterdata: gloablfilter } }, faultActive)
    fetchData({ url: API_URL_MAIN + "chargingpage/totalvehiclecount", body: { filterdata: gloablfilter } }, vehicleActive)
  }, [gloablfilter])

  const appyDataModal = (data) => {
    const res_result = data;
    const sortedActivities = res_result.sort((a, b) => b.fields.gun_start[0].localeCompare(a.fields.gun_start[0]))

    let responce = {};

    if (res_result.length != 0) {
      let temp_result = res_result;
      setModaldata(temp_result);
    } else {
      setModaldata([]);
    }
  }

  const appyDataModal1 = (data) => {
    setModaldata1(data);
    console.log("datatata",data[0]._source.Fault_Name);
  }

  const loadModalData = () => {
    setCurrentRadioValue("optioncharging")
    fetchData({ url: API_URL_MAIN + "chargingpage/Total_charged_cycle", body: { filterdata: gloablfilter } }, appyDataModal)
  }
  const loadModalData1 = () => {
    fetchData({ url: API_URL_MAIN + "chargingpage/faultycyclepopup", body: { filterdata: gloablfilter, clickedKpi : 'faulty' } }, appyDataModal1)
  }
  const loadModalData2 = () => {
    fetchData({ url: API_URL_MAIN + "chargingpage/faultycyclepopup", body: { filterdata: gloablfilter, clickedKpi : 'inturrupt' } }, appyDataModal1)
  }

  const handleRadioChange = (e) => {
    setCurrentRadioValue(e.target.value);
  };
  const handlePlatformChange = (event) => {
    event.preventDefault();
    const toggel = event.target.value
    if (toggel === "optioncharging") {
      fetchData({ url: API_URL_MAIN + "chargingpage/Total_charged_cycle", body: { filterdata: gloablfilter } }, appyDataModal)
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage/Total_outliers_cycle", body: { filterdata: gloablfilter } }, appyDataModal)
    }
  }

  let loader = (<div style={{ margin: "auto" }}><ThreeCircles
    height="50"
    width="40"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel="three-circles-rotating"
    outerCircleColor="#3498db"
    innerCircleColor="#dec52d"
    middleCircleColor="#db213a"
  /></div>)

  const loggedInUser = useSelector(selectLoggedInUser);
  let divAttributes = {};
  if (loggedInUser.flagForHideShow === "ERC") {
    divAttributes["data-bs-toggle"] = 'modal';
    divAttributes["data-bs-target"] = '#staticBackdrop';
    divAttributes.onClick = { loadModalData };
  } else {
    divAttributes = divAttributes;
  }

  return (
    <>
      <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="inlineRadioOptionsCharging" id="inlineRadio1" value="optioncharging" checked={currentRadioValue === 'optioncharging'} onChange={handleRadioChange} onClick={handlePlatformChange} />
                    <label className="form-check-label" htmlFor="inlineRadio1">Charged cycles</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="inlineRadioOptionsOutlires" id="inlineRadio2" value="optionoutliers" checked={currentRadioValue === 'optionoutliers'} onChange={handleRadioChange} onClick={handlePlatformChange} />
                    <label className="form-check-label" htmlFor="inlineRadio2">Outliers</label>
                  </div>
                </div>
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">

              <div className="tablecontainer" style={{ overflowX: "scroll", minHeight: "300px" }}>
                <table className="table table-striped" style={{ width: "100%" }}>
                  <thead style={{ backgroundColor: '#32879c', color: '#fff', position: "sticky", top: 0, zIndex: 0 }}>
                    <tr>
                      <th scope="col">Cycle</th>
                      <th scope="col">Vehicle Id</th>
                      <th scope="col">Gun Start</th>
                      <th scope="col">Gun End</th>
                      <th scope="col">Charge Type</th>
                      <th scope="col">Soc Start</th>
                      <th scope="col">Soc End</th>
                      <th scope="col">DeltaSoc</th>
                      <th scope="col">GunDurationInMin</th>
                      <th scope="col">TimeBeforChargeStartInMin</th>
                      <th scope="col">GunAfterfullchargeInMin</th>
                      <th scope="col">InterruptDurationInMin</th>
                      <th scope="col">NoOfInterrupt</th>
                      <th scope="col">chargeDurationInMin</th>
                      <th scope="col">SC20_100TimeInMin</th>
                      <th scope="col">FC10_80TimeInMin</th>
                      <th scope="col">EA_kWH</th>
                      <th scope="col"> ROC</th>
                      <th scope="col"> OBC_max_Temp</th>
                      <th scope="col"> BMS_pack_Current</th>
                      <th scope="col">start_BMS_Pack_Ah</th>
                      <th scope="col">end_BMS_Pack_Ah</th>
                      <th scope="col">start_BMS_Pack_Voltage</th>
                      <th scope="col">end_BMS_Pack_Voltage</th>
                      <th scope="col">BMS_Max_Cell_Temp</th>
                      {/* <th scope="col"> OBC_max_Temp</th> */}
                      <th scope="col">Max_BCS_Coolant_In</th>
                      <th scope="col">Max_BCS_Coolant_Out</th>
                      <th scope="col">BMS_Max_Cell_Voltage</th>
                      <th scope="col">BMS_Min_Cell_Voltage</th>
                      <th scope="col">BMS_max_cell_voltage_charge_end</th>
                      <th scope="col">BMS_min_cell_voltage_charge_end</th>
                      <th scope="col">Delta_cell_voltage_charge_end</th>
                      <th scope="col">FCStartTime</th>
                      <th scope="col">LCEndTime</th>
                      <th scope="col">Delta_cell_voltage_after_2_hour_time</th>
                      <th scope="col">BMS_max_cell_voltage_after_2_hour</th>
                      <th scope="col">BMS_min_cell_voltage_after_2_hour</th>
                      <th scope="col">Delta_cell_voltage_after_2_hour</th>
                      <th scope="col">Fault_occ</th>
                      <th scope="col">Fault_name</th>
                      <th scope="col">odo_end</th>
                      <th scope="col">max_odometer</th>
                      <th scope="col">LOB</th>
                      <th scope="col">PL</th>
                      <th scope="col">PPL</th>
                      <th scope="col">DLR ORG CITY</th>
                      <th scope="col">Eventdate</th>
                    </tr>
                  </thead>
                  <tbody>

                    {isLoading ? loader : (modaldata.length === 0) ? <tr><td colSpan='35' className="alert alert-danger no_data" style={{ background: "#f4c2ce" }}>No records found</td></tr> : modaldata.map((x, index) => {
                      let SC20_100TimeInMin = 0
                      let FC10_80TimeInMin = 0
                      let date = new Date(x.fields.eventdate);
                      let fdate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
                      if (x.fields.SC20_100TimeInMin) {
                        SC20_100TimeInMin = x.fields.SC20_100TimeInMin
                      }
                      if (x.fields.FC10_80TimeInMin) {
                        FC10_80TimeInMin = x.fields.SC20_100TimeInMin
                      }
                      return (<tr key={index}>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{index + 1}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.vehicleId}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.gun_start}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.gun_end}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.chargeType}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.soc_start}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.soc_end}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.delta_soc}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.gunDurationInMin}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.timeBeforChargeStartInMin}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.gunAfterfullchargeInMin}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.InterruptDurationInMin}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.NoOfInterrupt}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.chargeDurationInMin}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{SC20_100TimeInMin}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{FC10_80TimeInMin}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.EA_kWH}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.ROC}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.OBC_max_Temp}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.BMS_Pack_Current}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.start_BMS_Pack_Ah}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.end_BMS_Pack_Ah}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.start_BMS_Pack_Voltage}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.end_BMS_Pack_Voltage}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.BMS_Max_Cell_Temp}</td>
                        {/* <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.OBC_max_Temp}</td> */}
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.Max_BCS_Coolant_In}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.Max_BCS_Coolant_Out}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.BMS_Max_Cell_Voltage}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.BMS_Min_Cell_Voltage}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.BMS_max_cell_voltage_charge_end}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.BMS_min_cell_voltage_charge_end}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.delta_cell_voltage_charge_end}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.FCStartTime}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.LCEndTime}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.delta_cell_voltage_after_2_hour_time}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.BMS_max_cell_voltage_after_2_hour}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.BMS_min_cell_voltage_after_2_hour}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.delta_cell_voltage_after_2_hour}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.Fault_occ}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.fault_name}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.odo_end}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.max_odometer}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.LOB}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.PL}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.PPL}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x.fields.DLR_ORG_CITY}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{fdate}</td>
                      </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="staticBackdrop1" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <div className="row">
                <div className="col-lg-12">
                  Critical Faulty Cycles
                </div>
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">

              <div className="tablecontainer" style={{ overflowX: "scroll", minHeight: "300px" }}>
                <table className="table table-striped" style={{ width: "100%" }}>
                  <thead style={{ backgroundColor: '#32879c', color: '#fff', position: "sticky", top: 0, zIndex: 0 }}>
                    <tr>
                      <th scope="col">Cycle</th>
                      <th scope="col">Gun Start</th>
                      <th scope="col">Gun End</th>
                      <th scope="col">Signal Occ Count</th>
                      <th scope="col">Fault Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {console.log("modaldata1",modaldata1[0]._source.gun_start)} */}
                    {isLoading ? loader : (modaldata1.length === 0) ? <tr><td colSpan='35' className="alert alert-danger no_data" style={{ background: "#f4c2ce" }}>No records found</td></tr> : modaldata1.map((x, index) => {
                      return (<tr key={index}>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{index + 1}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.gun_start}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.gun_end}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.Fault_occ}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.Fault_Name}</td>
                      </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="staticBackdrop2" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <div className="row">
                <div className="col-lg-12">
                  Interruption Cycles
                </div>
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">

              <div className="tablecontainer" style={{ overflowX: "scroll", minHeight: "300px" }}>
                <table className="table table-striped" style={{ width: "100%" }}>
                  <thead style={{ backgroundColor: '#32879c', color: '#fff', position: "sticky", top: 0, zIndex: 0 }}>
                    <tr>
                      <th scope="col">Cycle</th>
                      <th scope="col">Gun Start</th>
                      <th scope="col">Gun End</th>
                      <th scope="col">NoOfInterrupt</th>
                      <th scope="col">InterruptDurationInMin</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? loader : (modaldata1.length === 0) ? <tr><td colSpan='35' className="alert alert-danger no_data" style={{ background: "#f4c2ce" }}>No records found</td></tr> : modaldata1.map((x, index) => {
                      return (<tr key={index}>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{index + 1}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.gun_start}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.gun_end}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.NoOfInterrupt}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.InterruptDurationInMin}</td>
                      </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="kpi my-3">
        <div className="row">
          <div className="col-md-6 col-lg-2 mb-3">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{totalvehicle.slow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{totalvehicle.fast}</strong> Fast |</span>
                <span className="kpiNotificationBoth"><strong>{totalvehicle.both}</strong> Both</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/EV-Logo 1.png" /> </div>
                <div className="ps-3">
                  <p className="h5 m-0">{topdata.totalvehiclecount}</p>
                  <p className="m-0"><small className="text-muted">Total vehicle count</small></p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-2 mb-3">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{faultactive.totalslow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{faultactive.totalfast}</strong> Fast</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/charging 1.png" /> </div>
                {
                  loggedInUser.flagForHideShow === "ERC" ?
                    <div className="pl-1" data-bs-toggle="modal" data-bs-target="#staticBackdrop" style={{ cursor: "pointer" }} onClick={loadModalData}>
                      <div className="ps-3">
                        <p className="h5 m-0">{faultactive.totalcharged}</p>
                        <p className="m-0"><small className="text-muted">Total charged cycles</small></p>
                      </div>
                    </div> :
                    <div className="pl-1">
                      <div className="ps-3">
                        <p className="h5 m-0">{faultactive.totalcharged}</p>
                        <p className="m-0"><small className="text-muted">Total charged cycles</small></p>
                      </div>
                    </div>
                }
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-2 mb-3">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{faultactive.fault_occ_slow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{faultactive.fault_occ_fast}</strong> Fast</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/fault_kpi.svg" /> </div>
                {
                  loggedInUser.flagForHideShow === "ERC" ?
                <div className="pl-1" data-bs-toggle="modal" data-bs-target="#staticBackdrop1" style={{ cursor: "pointer" }} onClick={loadModalData1}>
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.fault_occ}</p>
                  <p className="m-0"><small className="text-muted">Critical Faulty cycles</small></p>
                </div>
                </div>:
                <div className="pl-3" >
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.fault_occ}</p>
                  <p className="m-0"><small className="text-muted">Critical Faulty cycles</small></p>
                </div>
                </div>
              }

              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-2 mb-3">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{faultactive.faultyslow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{faultactive.faultyfast}</strong> Fast</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/charging-station 1 (1).png" /> </div>
                {
                  loggedInUser.flagForHideShow === "ERC" ?
                <div className="pl-1" data-bs-toggle="modal" data-bs-target="#staticBackdrop2" style={{ cursor: "pointer" }} onClick={loadModalData2}>
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.faulty}</p>
                  <p className="m-0"><small className="text-muted">Interruption cycles</small></p>
                </div>
                </div>:
                <div className="pl-1">
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.faulty}</p>
                  <p className="m-0"><small className="text-muted">Interruption cycles</small></p>
                </div>
                </div>
                }

              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-2 mb-3">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{faultactive.opportunityslow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{faultactive.opportunityfast}</strong> Fast</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/electric 1 (1).png" /> </div>
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.opportunitycharged}</p>
                  <p className="m-0"><small className="text-muted">Opportunity charged cycles</small></p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-2">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{faultactive.fullchargedslow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{faultactive.fullchargedfast}</strong> Fast</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/electric-car 1.png" /> </div>
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.fullcharged}</p>
                  <p className="m-0"><small className="text-muted">Full charged cycles</small></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
